import { AuiChartBase } from './AuiChartBase';
import type { AuiRendererProps } from '../../registry';

export function AuiLineChart(props: AuiRendererProps) {
  return <AuiChartBase {...props} testId="aui-line-chart" />;
}
